import { Injectable } from '@angular/core';

export interface NavigationItem {
  label: string;
  route: string;
  icon: string;
  children?: NavigationItem[];
}

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  getNavigationForGroups(groups: string[]): NavigationItem[] {
    console.log('🧭 Navigation Service - Processing groups:', groups);
    
    if (groups.includes('ADMINS')) {
      console.log('✅ User is ADMIN - Loading admin navigation');
      return [
        { label: 'Dashboard', route: '/admin', icon: 'dashboard' },
        { label: 'User Management', route: '/admin/users', icon: 'people' },
        { label: 'Field Configuration', route: '/admin/field-config', icon: 'settings_applications' },
        { label: 'System Settings', route: '/admin/settings', icon: 'settings' },
        { label: 'Reports', route: '/admin/reports', icon: 'analytics' }
      ];
    }
    
    if (groups.includes('SALES_REPS')) {
      console.log('✅ User is SALES_REP - Loading sales navigation');
      return [
        { label: 'Dashboard', route: '/sales', icon: 'dashboard' },
        { label: 'Commission Calculator', route: '/sales/commission', icon: 'calculate' },
        { label: 'Leads', route: '/sales/leads', icon: 'contacts' },
        { label: 'Performance', route: '/sales/performance', icon: 'trending_up' }
      ];
    }
    
    if (groups.includes('Technicians')) {
      console.log('✅ User is TECHNICIAN - Loading technician navigation');
      return [
        { label: 'Dashboard', route: '/employee', icon: 'dashboard' },
        { label: 'Schedule', route: '/employee/schedule', icon: 'calendar_today' },
        { label: 'Customers', route: '/employee/customers', icon: 'people' },
        { label: 'Services', route: '/employee/services', icon: 'build' }
      ];
    }
    
    // Default customer navigation
    console.log('👤 User is CUSTOMER (default) - Loading customer navigation');
    return [
      { label: 'My Account', route: '/customer', icon: 'account_circle' },
      { label: 'Services', route: '/customer/services', icon: 'build' },
      { label: 'Billing', route: '/customer/billing', icon: 'payment' },
      { label: 'Support', route: '/customer/support', icon: 'help' }
    ];
  }

  getPortalNameForGroups(groups: string[]): string {
    console.log('🏢 Portal Name Service - Processing groups:', groups);
    
    if (groups.includes('ADMINS')) {
      console.log('🔧 Portal: Admin Portal');
      return 'Admin Portal';
    }
    if (groups.includes('Technicians')) {
      console.log('👷 Portal: Technician Portal');
      return 'Technician Portal';
    }
    if (groups.includes('SALES_REPS')) {
      console.log('💼 Portal: Sales Portal');
      return 'Sales Portal';
    }
    console.log('👤 Portal: Customer Portal (default)');
    return 'Customer Portal';
  }

  getDefaultRouteForGroups(groups: string[]): string {
    console.log('🛣️ Default Route Service - Processing groups:', groups);
    
    // Everyone goes to dashboard, but the menu will be different based on groups
    console.log('➡️ Redirecting to: /dashboard');
    return '/dashboard';
  }
}